var _path, _ellipse, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5155_113320",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 23,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7361 16.9187C17.4895 17.1653 17.2291 17.3896 16.9573 17.5917C16.681 17.7972 16.5007 18.113 16.5007 18.4573V20.9055C16.5007 21.5973 17.1871 22.0772 17.8028 21.7617C18.7978 21.2518 19.7314 20.5802 20.5646 19.7471C24.8596 15.452 24.8596 8.48838 20.5646 4.19333C16.3661 -0.00516105 9.61761 -0.0995457 5.30446 3.91018L3.27747 1.51931C2.99349 1.18436 2.4466 1.35194 2.39903 1.78848L1.50082 10.0309C1.4662 10.3486 1.73437 10.6168 2.05204 10.5821L10.2945 9.68393C10.731 9.63636 10.8986 9.08947 10.5637 8.80549L8.13268 6.7445C10.8807 4.29216 15.099 4.38458 17.7361 7.02176C20.4691 9.75471 20.4691 14.1857 17.7361 16.9187Z",
    fill: "url(#paint0_linear_5155_113320)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.27778,
    cy: 14.2266,
    rx: 5.77778,
    ry: 2.22658,
    fill: "url(#paint1_linear_5155_113320)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27778 16.4529C11.4688 16.4529 14.0556 15.456 14.0556 14.2263V16.6931C14.0556 17.9228 11.4688 18.9197 8.27778 18.9197C5.0868 18.9197 2.5 17.9228 2.5 16.6931V14.2263C2.5 15.456 5.0868 16.4529 8.27778 16.4529Z",
    fill: "url(#paint2_linear_5155_113320)",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 14.2263C2.5 14.2197 2.50008 14.213 2.50023 14.2064L2.5 14.2263Z",
    fill: "url(#paint3_linear_5155_113320)",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.055 14.1949L14.0556 14.2263C14.0556 14.2158 14.0554 14.2054 14.055 14.1949Z",
    fill: "url(#paint4_linear_5155_113320)",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27778 18.9192C11.4688 18.9192 14.0556 17.9224 14.0556 16.6927V19.1594C14.0556 20.3891 11.4688 21.386 8.27778 21.386C5.0868 21.386 2.5 20.3891 2.5 19.1594V16.6927C2.5 17.9224 5.0868 18.9192 8.27778 18.9192Z",
    fill: "url(#paint5_linear_5155_113320)",
    fillOpacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 16.6927C2.5 16.686 2.50008 16.6794 2.50023 16.6727L2.5 16.6927Z",
    fill: "url(#paint6_linear_5155_113320)",
    fillOpacity: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.055 16.6613L14.0556 16.6927C14.0556 16.6822 14.0554 16.6717 14.055 16.6613Z",
    fill: "url(#paint7_linear_5155_113320)",
    fillOpacity: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27778 21.3857C11.4688 21.3857 14.0556 20.3889 14.0556 19.1592V21.6259C14.0556 22.8556 11.4688 23.8524 8.27778 23.8524C5.0868 23.8524 2.5 22.8556 2.5 21.6259V19.1592C2.5 20.3889 5.0868 21.3857 8.27778 21.3857Z",
    fill: "url(#paint8_linear_5155_113320)",
    fillOpacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 19.1592C2.5 19.1525 2.50008 19.1458 2.50023 19.1392L2.5 19.1592Z",
    fill: "url(#paint9_linear_5155_113320)",
    fillOpacity: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.055 19.1277L14.0556 19.1592C14.0556 19.1486 14.0554 19.1382 14.055 19.1277Z",
    fill: "url(#paint10_linear_5155_113320)",
    fillOpacity: 0.1
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5155_113320)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    fill: "#302E2E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5155_113320",
    x1: 9.75608,
    y1: 9.32751,
    x2: 19.9649,
    y2: 22.8665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5155_113320",
    x1: 6.78162,
    y1: 13.7813,
    x2: 8.06223,
    y2: 17.9116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5155_113320",
    x1: 6.78162,
    y1: 16.0848,
    x2: 8.20748,
    y2: 20.4193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5155_113320",
    x1: 6.78162,
    y1: 16.0848,
    x2: 8.20748,
    y2: 20.4193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5155_113320",
    x1: 6.78162,
    y1: 16.0848,
    x2: 8.20748,
    y2: 20.4193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5155_113320",
    x1: 6.78162,
    y1: 18.5512,
    x2: 8.20748,
    y2: 22.8856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5155_113320",
    x1: 6.78162,
    y1: 18.5512,
    x2: 8.20748,
    y2: 22.8856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5155_113320",
    x1: 6.78162,
    y1: 18.5512,
    x2: 8.20748,
    y2: 22.8856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5155_113320",
    x1: 6.78162,
    y1: 21.0176,
    x2: 8.20748,
    y2: 25.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5155_113320",
    x1: 6.78162,
    y1: 21.0176,
    x2: 8.20748,
    y2: 25.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5155_113320",
    x1: 6.78162,
    y1: 21.0176,
    x2: 8.20748,
    y2: 25.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditItem);
export default __webpack_public_path__ + "static/media/CreditItem.d37670ac4a2b0aad2416d6e69260c7f3.svg";
export { ForwardRef as ReactComponent };